import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
declare global {
  interface Window {
    fbq: any;
  }
}
// Lazy load all pages — only the visited route downloads
const LandingPage = lazy(() => import('./pages/LandingPage').then(m => ({
  default: m.LandingPage
})));
const ThankYouPage = lazy(() => import('./pages/ThankYouPage').then(m => ({
  default: m.ThankYouPage
})));
const ThankYouMPage = lazy(() => import('./pages/ThankYouMPage').then(m => ({
  default: m.ThankYouMPage
})));
const VslPage = lazy(() => import('./pages/VslPage').then(m => ({
  default: m.VslPage
})));
const VslIgPage = lazy(() => import('./pages/VslIgPage').then(m => ({
  default: m.VslIgPage
})));
const VslDisqualifyPage = lazy(() => import('./pages/VslDisqualifyPage').then(m => ({
  default: m.VslDisqualifyPage
})));
const UpSellDisqualifyPage = lazy(() => import('./pages/UpSellDisqualifyPage').then(m => ({
  default: m.UpSellDisqualifyPage
})));
const OptinVslPage = lazy(() => import('./pages/OptinVslPage').then(m => ({
  default: m.OptinVslPage
})));
const RetargetingPage = lazy(() => import('./pages/RetargetingPage').then(m => ({
  default: m.RetargetingPage
})));
const ConfirmationPage = lazy(() => import('./pages/ConfirmationPage').then(m => ({
  default: m.ConfirmationPage
})));
const PurchaseBookACallWebinarPage = lazy(() => import('./pages/PurchaseBookACallWebinarPage').then(m => ({
  default: m.PurchaseBookACallWebinarPage
})));
const MetaJuevesPage = lazy(() => import('./pages/MetaJuevesPage').then(m => ({
  default: m.MetaJuevesPage
})));
const ReplayPage = lazy(() => import('./pages/ReplayPage').then(m => ({
  default: m.ReplayPage
})));
const LloydPage = lazy(() => import('./pages/LloydPage').then(m => ({
  default: m.LloydPage
})));
const HeyLloydPage = lazy(() => import('./pages/HeyLloydPage').then(m => ({
  default: m.HeyLloydPage
})));
const HeyLloydCustomsPage = lazy(() => import('./pages/HeyLloydCustomsPage').then(m => ({
  default: m.HeyLloydCustomsPage
})));
const HeyLloydBookACallPage = lazy(() => import('./pages/HeyLloydBookACallPage').then(m => ({
  default: m.HeyLloydBookACallPage
})));
const WebinarReplyPage = lazy(() => import('./pages/WebinarReplyPage').then(m => ({
  default: m.WebinarReplyPage
})));
const WebinarReplyPageIndia = lazy(() => import('./pages/WebinarReplyPageIndia').then(m => ({
  default: m.WebinarReplyPageIndia
})));
const BookingQualificationPage = lazy(() => import('./pages/BookingQualificationPage').then(m => ({
  default: m.BookingQualificationPage
})));
const BookCallInternalPage = lazy(() => import('./pages/BookCallInternalPage').then(m => ({
  default: m.BookCallInternalPage
})));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage').then(m => ({
  default: m.PrivacyPage
})));
const TermsPage = lazy(() => import('./pages/TermsPage').then(m => ({
  default: m.TermsPage
})));
const RegaloPage = lazy(() => import('./pages/RegaloPage').then(m => ({
  default: m.RegaloPage
})));
const MeditationsPage = lazy(() => import('./pages/MeditationsPage').then(m => ({
  default: m.MeditationsPage
})));
const LlamadaConfirmationPage = lazy(() => import('./pages/LlamadaConfirmationPage').then(m => ({
  default: m.LlamadaConfirmationPage
})));
const LlamadaAiPage = lazy(() => import('./pages/LlamadaAiPage').then(m => ({
  default: m.LlamadaAiPage
})));
const LlamadasSemanalesCursoPage = lazy(() => import('./pages/LlamadasSemanalesCursoPage').then(m => ({
  default: m.LlamadasSemanalesCursoPage
})));
const BookCallStrategyPage = lazy(() => import('./pages/BookCallStrategyPage').then(m => ({
  default: m.BookCallStrategyPage
})));
const WebinarJuevesNewPage = lazy(() => import('./pages/WebinarJuevesNewPage').then(m => ({
  default: m.WebinarJuevesNewPage
})));
const BreakoutVideoPage = lazy(() => import('./pages/BreakoutVideoPage').then(m => ({
  default: m.BreakoutVideoPage
})));
const ReplayOfferPage = lazy(() => import('./pages/ReplayOfferPage').then(m => ({
  default: m.ReplayOfferPage
})));
const CaseStudy1050Page = lazy(() => import('./pages/CaseStudy1050Page').then(m => ({
  default: m.CaseStudy1050Page
})));
const ComoIaPage = lazy(() => import('./pages/ComoIaPage').then(m => ({
  default: m.ComoIaPage
})));
const WelcomePage = lazy(() => import('./pages/WelcomePage').then(m => ({
  default: m.WelcomePage
})));
const HistoriaPage = lazy(() => import('./pages/HistoriaPage').then(m => ({
  default: m.HistoriaPage
})));
const LeadMagnetHeyLloydDemoPage = lazy(() => import('./pages/LeadMagnetHeyLloydDemoPage').then(m => ({
  default: m.LeadMagnetHeyLloydDemoPage
})));
const Faltan3DiasPage = lazy(() => import('./pages/Faltan3DiasPage').then(m => ({
  default: m.Faltan3DiasPage
})));
const Faltan2DiasPage = lazy(() => import('./pages/Faltan2DiasPage').then(m => ({
  default: m.Faltan2DiasPage
})));
const Faltan1DiaPage = lazy(() => import('./pages/Faltan1DiaPage').then(m => ({
  default: m.Faltan1DiaPage
})));
const Faltan3HrsPage = lazy(() => import('./pages/Faltan3HrsPage').then(m => ({
  default: m.Faltan3HrsPage
})));
const CoachingPage = lazy(() => import('./pages/CoachingPage').then(m => ({
  default: m.CoachingPage
})));
const CheckoutLloydPage = lazy(() => import('./pages/CheckoutLloydPage').then(m => ({
  default: m.CheckoutLloydPage
})));
const VipCallsPage = lazy(() => import('./pages/VipCallsPage').then(m => ({
  default: m.VipCallsPage
})));
const VslWhatsappPage = lazy(() => import('./pages/VslWhatsappPage').then(m => ({
  default: m.VslWhatsappPage
})));
const ThankYouOfferPage = lazy(() => import('./pages/ThankYouOfferPage').then(m => ({
  default: m.ThankYouOfferPage
})));
const ThankYouDownsalePage = lazy(() => import('./pages/ThankYouDownsalePage').then(m => ({
  default: m.ThankYouDownsalePage
})));
const CarSalesmanPage = lazy(() => import('./pages/CarSalesmanPage').then(m => ({
  default: m.CarSalesmanPage
})));
const NineToFivePage = lazy(() => import('./pages/NineToFivePage').then(m => ({
  default: m.NineToFivePage
})));
const CarSalesmanWebinarPage = lazy(() => import('./pages/CarSalesmanWebinarPage').then(m => ({
  default: m.CarSalesmanWebinarPage
})));
const EscapaDelDealershipGraciasPage = lazy(() => import('./pages/EscapaDelDealershipGraciasPage').then(m => ({
  default: m.EscapaDelDealershipGraciasPage
})));
const ThankYouDealershipPage = lazy(() => import('./pages/ThankYouDealershipPage').then(m => ({
  default: m.ThankYouDealershipPage
})));
const ConfirmationThankYouPage = lazy(() => import('./pages/ConfirmationThankYouPage').then(m => ({
  default: m.ConfirmationThankYouPage
})));
// Minimal loading screen matching the dark theme
function PageLoader() {
  return <div className="min-h-screen bg-black flex items-center justify-center" data-id="element-0" data-mp="2pi7q2g5z95yu">
      <div className="w-8 h-8 border-2 border-[#00f7fc]/30 border-t-[#00f7fc] rounded-full animate-spin" data-id="element-1" data-mp="33go5cvhwo4sl" />
    </div>;
}
export function App() {
  useEffect(() => {
    // Global Facebook Pixel — fires on every page
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
  }, []);
  return <BrowserRouter data-id="element-2" data-mp="2ge9h9vmeiri5">
      <Suspense fallback={<PageLoader data-id="element-4" data-mp="2gfkgrj8tdd3g" />} data-id="element-3" data-mp="2ge0zpqfc2y0m">
        <Routes data-id="element-5" data-mp="2gf2m2r1sv6xn">
          <Route path="/" element={<Navigate to="/meta-jueves" replace data-id="element-7" data-mp="2kge52dq64twv" />} data-id="element-6" data-mp="2ggn81sa1thjw" />
          <Route path="/meta-martes" element={<LandingPage data-id="element-9" data-mp="30vdmshatld8a" />} data-id="element-8" data-mp="2kf31adwq3m5r" />
          <Route path="/meta-jueves" element={<MetaJuevesPage data-id="element-11" data-mp="30ulylrjjyhs1" />} data-id="element-10" data-mp="30vn8vtsqv08p" />
          <Route path="/marca-el-gol" element={<LandingPage data-id="element-13" data-mp="2vxc3pwde9dwt" />} data-id="element-12" data-mp="2vwamtb9p5x76" />
          <Route path="/meta-jueves-lp2" element={<LandingPage data-id="element-15" data-mp="2qwxtq8s8ftw5" />} data-id="element-14" data-mp="2vx289t9kyejq" />
          <Route path="/meta-jueves-rr" element={<LandingPage data-id="element-17" data-mp="2qzahx3ol30hn" />} data-id="element-16" data-mp="2qw68nrw9hek4" />
          <Route path="/reregister" element={<LandingPage data-id="element-19" data-mp="2lx34e9o3vcd7" />} data-id="element-18" data-mp="2lyd1avj82ei9" />
          <Route path="/jon-test" element={<LandingPage data-id="element-21" data-mp="2hw9dr8ja3jgm" />} data-id="element-20" data-mp="2lxuu53v0ufvk" />
          <Route path="/en-vivo" element={<LandingPage data-id="element-23" data-mp="2hxu9h1hbx8g2" />} data-id="element-22" data-mp="2hxks22aco9lz" />
          <Route path="/bienvenidos" element={<LandingPage data-id="element-25" data-mp="2d4ro3gmph5ay" />} data-id="element-24" data-mp="2d5t1hrr723vu" />
          <Route path="/bienvenidos-m" element={<LandingPage data-id="element-27" data-mp="286pwg7b7rxnv" />} data-id="element-26" data-mp="2d4hwjom0iq35" />
          <Route path="/news-brake" element={<LandingPage data-id="element-29" data-mp="286zm1tsck2t1" />} data-id="element-28" data-mp="285ws1czq9k8w" />
          <Route path="/organic-martes" element={<LandingPage data-id="element-31" data-mp="238obthy53qaa" />} data-id="element-30" data-mp="237n0dcd7p1s1" />
          <Route path="/organic-jueves" element={<LandingPage data-id="element-33" data-mp="1y8adwsq95wpz" />} data-id="element-32" data-mp="239g8kw3h3u25" />
          <Route path="/yt-jueves" element={<LandingPage data-id="element-35" data-mp="1y7qt9497wu89" />} data-id="element-34" data-mp="1y7h2hegcmj1i" />
          <Route path="/webinar-jueves-new" element={<WebinarJuevesNewPage data-id="element-37" data-mp="1u7zzcroe9xzi" />} data-id="element-36" data-mp="1u6x5cavrzffd" />
          <Route path="/thank-you" element={<ThankYouPage data-id="element-39" data-mp="9pfmp1inbind" />} data-id="element-38" data-mp="1u91iljfkdqsb" />
          <Route path="/thank-you-offer" element={<ThankYouOfferPage data-id="element-41" data-mp="9r8u4j1326wf" />} data-id="element-40" data-mp="9o4i4zhdm6v7" />
          <Route path="/thank-you-downsale" element={<ThankYouDownsalePage data-id="element-43" data-mp="doofo45v3chv" />} data-id="element-42" data-mp="dpye4ugmmmp1" />
          <Route path="/thank-you-m" element={<ThankYouMPage data-id="element-45" data-mp="iqm73lof1dlw" />} data-id="element-44" data-mp="ipu9k5b9d5sz" />
          <Route path="/vsl" element={<VslPage data-id="element-47" data-mp="nonm9viq0ss3" />} data-id="element-46" data-mp="iqdvry7xygct" />
          <Route path="/vsl-whatsapp" element={<VslWhatsappPage data-id="element-49" data-mp="no5m4nsxtuew" />} data-id="element-48" data-mp="noxfdrz2bg20" />
          <Route path="/vsl-disqualified" element={<VslDisqualifyPage data-id="element-51" data-mp="3m7cf263k60q8" />} data-id="element-50" data-mp="3m6b5y763rob5" />
          <Route path="/up-sell-disqualify" element={<UpSellDisqualifyPage data-id="element-53" data-mp="3r4ur45cvgw2g" />} data-id="element-52" data-mp="3m484mqzi28r4" />
          <Route path="/vsl-ig" element={<VslIgPage data-id="element-55" data-mp="3r31jamqiw5sv" />} data-id="element-54" data-mp="3r5xh8b2deuhb" />
          <Route path="/optin-vsl" element={<OptinVslPage data-id="element-57" data-mp="3w3p9x7auakmk" />} data-id="element-56" data-mp="3w3z0ox3pkvtb" />
          <Route path="/retargeting" element={<RetargetingPage data-id="element-59" data-mp="4qbf2fbddsz5" />} data-id="element-58" data-mp="3w2e657he9cvg" />
          <Route path="/purchase-book-a-call" element={<ConfirmationPage data-id="element-61" data-mp="33ftf684tz2sf" />} data-id="element-60" data-mp="4ql522wf004u" />
          <Route path="/purchase-book-a-call-webinar" element={<PurchaseBookACallWebinarPage data-id="element-63" data-mp="33dpahnz3xzr3" />} data-id="element-62" data-mp="33glariyfh0ip" />
          <Route path="/llamadas-semanales-curso" element={<LlamadasSemanalesCursoPage data-id="element-65" data-mp="38ctjadi4dvgw" />} data-id="element-64" data-mp="38e4nufje3792" />
          <Route path="/book-call-strategy" element={<BookCallStrategyPage data-id="element-67" data-mp="2f6vhb5yrdm5a" />} data-id="element-66" data-mp="2f7wsrbjosanj" />
          <Route path="/replay" element={<ReplayPage data-id="element-69" data-mp="2k56r5gp1zwni" />} data-id="element-68" data-mp="2k5ya9s1gs1ww" />
          <Route path="/lloyd" element={<LloydPage data-id="element-71" data-mp="2p5b8f8xscves" />} data-id="element-70" data-mp="2k4dgw5qvyp0m" />
          <Route path="/checkout-lloyd" element={<CheckoutLloydPage data-id="element-73" data-mp="2p5ujc5p0qjjb" />} data-id="element-72" data-mp="2p51hnj4x2k81" />
          <Route path="/heylloyd" element={<HeyLloydPage data-id="element-75" data-mp="2u4nrrjpg7kcm" />} data-id="element-74" data-mp="2u4e1dv0hrb6e" />
          <Route path="/reply-webinar" element={<HeyLloydPage data-id="element-77" data-mp="1wgnl77th7vyl" />} data-id="element-76" data-mp="2u3w0um6sqaso" />
          <Route path="/webinar-reply" element={<WebinarReplyPage data-id="element-79" data-mp="1wigqaiofy84h" />} data-id="element-78" data-mp="1whf5vnljc9a3" />
          <Route path="/in" element={<WebinarReplyPageIndia data-id="element-81" data-mp="21exbb40cg6dc" />} data-id="element-80" data-mp="21fgxwy0xvixp" />
          <Route path="/book-call" element={<BookingQualificationPage data-id="element-83" data-mp="26f3bj8koj171" />} data-id="element-82" data-mp="21g079qciwz04" />
          <Route path="/book-call-internal" element={<BookCallInternalPage data-id="element-85" data-mp="26cyzu4gjgxw7" />} data-id="element-84" data-mp="26e1nm3ikek7w" />
          <Route path="/vip-calls" element={<VipCallsPage data-id="element-87" data-mp="2b6urkp67loix" />} data-id="element-86" data-mp="2b5rzidx5hg1f" />
          <Route path="/llamada-ai" element={<LlamadaConfirmationPage data-id="element-89" data-mp="1dqxo2e28qy3i" />} data-id="element-88" data-mp="1dq5t95ggx4ea" />
          <Route path="/heylloyd-customs" element={<HeyLloydCustomsPage data-id="element-91" data-mp="1iopfz82vyk7p" />} data-id="element-90" data-mp="1dpw3nizc4z94" />
          <Route path="/heylloyd-book-a-call" element={<HeyLloydBookACallPage data-id="element-93" data-mp="3vzigfuw33nl8" />} data-id="element-92" data-mp="1inxskkjfzssi" />
          <Route path="/infocommerce-book-a-call" element={<HeyLloydBookACallPage data-id="element-95" data-mp="3vx635v19u1ei" />} data-id="element-94" data-mp="3vyh4lo78ux2g" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-97" data-mp="3ryf0l8e1drk0" />} data-id="element-96" data-mp="3rxnh2vxprka3" />
          <Route path="/terms" element={<TermsPage data-id="element-99" data-mp="3myaumcar8f81" />} data-id="element-98" data-mp="3rw2ohbuymbev" />
          <Route path="/regalo" element={<RegaloPage data-id="element-101" data-mp="3n0x3cf9dt0ru" />} data-id="element-100" data-mp="3mxiyn0d8wfh8" />
          <Route path="/meditations" element={<MeditationsPage data-id="element-103" data-mp="3hyo9lgoopuoo" />} data-id="element-102" data-mp="3hzzlk3saa8qv" />
          <Route path="/llamada-confirmacion" element={<LlamadaConfirmationPage data-id="element-105" data-mp="3d1698eoqgnsa" />} data-id="element-104" data-mp="3i1tx4rho0oia" />
          <Route path="/vid1" element={<BreakoutVideoPage videoId="1173156247" title="¿Y si HEYLLOYD no funciona para mi nicho o tipo de negocio?" videoNumber={1} data-id="element-107" data-mp="3d2h7jyzet3c0" />} data-id="element-106" data-mp="3d27lunledic4" />
          <Route path="/vid2" element={<BreakoutVideoPage videoId="1173156261" title="Ya he invertido en otros programas y no me funcionaron. ¿Qué hace a este diferente?" videoNumber={2} data-id="element-109" data-mp="348ul4zh3dcfh" />} data-id="element-108" data-mp="347jbwk4vncgz" />
          <Route path="/vid3" element={<BreakoutVideoPage videoId="1173156277" title="No tengo tiempo para implementar otro sistema complejo." videoNumber={3} data-id="element-111" data-mp="2u9n687upl9q9" />} data-id="element-110" data-mp="2uaepcj74dezn" />
          <Route path="/vid4" element={<BreakoutVideoPage videoId="1173156217" title="Me preocupa el costo de la inversión. ¿Cuál es el ROI real?" videoNumber={4} data-id="element-113" data-mp="2fmwqw2k5hglo" />} data-id="element-112" data-mp="2pdem0g1nmqc8" />
          <Route path="/vid5" element={<BreakoutVideoPage videoId="1173156206" title="¿No puedo simplemente hacer lo mismo con ChatGPT y otras herramientas gratuitas?" videoNumber={5} data-id="element-115" data-mp="2kk6inov0i4co" />} data-id="element-114" data-mp="2ko3yo1mamfsc" />
          <Route path="/replay-offer" element={<ReplayOfferPage data-id="element-117" data-mp="2aq6d5lvtix3f" />} data-id="element-116" data-mp="2aovbpspui1fh" />
          <Route path="/1050-7-dias" element={<CaseStudy1050Page data-id="element-119" data-mp="2yeh9cbqkk8ld" />} data-id="element-118" data-mp="2ydnyozohoyxy" />
          <Route path="/como-ia" element={<ComoIaPage data-id="element-121" data-mp="33dae9frsir9x" />} data-id="element-120" data-mp="33d0w2eczloes" />
          <Route path="/welcome" element={<WelcomePage data-id="element-123" data-mp="33ev6gyqmty4m" />} data-id="element-122" data-mp="33citkzzqedyf" />
          <Route path="/historia" element={<HistoriaPage data-id="element-125" data-mp="2pkudklmd35c6" />} data-id="element-124" data-mp="2pm5l8wixgx8k" />
          <Route path="/lead-magnet-heylloyd-demo" element={<LeadMagnetHeyLloydDemoPage data-id="element-127" data-mp="2tm5xqbmguycz" />} data-id="element-126" data-mp="2pjt58owqcwy5" />
          <Route path="/faltan-3-dias" element={<Faltan3DiasPage data-id="element-129" data-mp="3hca24l7hb251" />} data-id="element-128" data-mp="2tl4jxze2fxrk" />
          <Route path="/faltan-2-dias" element={<Faltan2DiasPage data-id="element-131" data-mp="3hayvmdmnfga8" />} data-id="element-130" data-mp="3hc0bcvem0qya" />
          <Route path="/faltan-1-dia" element={<Faltan1DiaPage data-id="element-133" data-mp="3m534x3je00eh" />} data-id="element-132" data-mp="3m41qcp35wvs0" />
          <Route path="/faltan-3-hrs" element={<Faltan3HrsPage data-id="element-135" data-mp="1anrix6mg2n0m" />} data-id="element-134" data-mp="3m5cuiq0is5jn" />
          <Route path="/coaching" element={<CoachingPage data-id="element-137" data-mp="15pgan0bsskki" />} data-id="element-136" data-mp="1amyi0ma62rqe" />
          <Route path="/car-salesman" element={<CarSalesmanPage data-id="element-139" data-mp="15p6ib63a61bn" />} data-id="element-138" data-mp="15q870dd7ymbu" />
          <Route path="/9-to-5" element={<NineToFivePage data-id="element-141" data-mp="1kem8okywg4qt" />} data-id="element-140" data-mp="1kecq3ig6ozv5" />
          <Route path="/car-saleman-webinar" element={<CarSalesmanWebinarPage data-id="element-143" data-mp="1ffjdds8q1cw1" />} data-id="element-142" data-mp="1kdt5ftz5fxdf" />
          <Route path="/car-salesman-webinar" element={<CarSalesmanWebinarPage data-id="element-145" data-mp="1fhm3ec9vj60r" />} data-id="element-144" data-mp="1fgkotxtng1ea" />
          <Route path="/escapa-del-dealership-gracias" element={<EscapaDelDealershipGraciasPage data-id="element-147" data-mp="rri94viksimf" />} data-id="element-146" data-mp="rovts9pg0ytn" />
          <Route path="/thank-you-dealership" element={<ThankYouDealershipPage data-id="element-149" data-mp="msox77ixszod" />} data-id="element-148" data-mp="mrnjevajdz2y" />
          <Route path="/confirmation-page" element={<ConfirmationThankYouPage data-id="element-151" data-mp="11p651orx3w66" />} data-id="element-150" data-mp="11oebejhvs8ij" />
          <Route path="*" element={<Navigate to="/meta-jueves" replace data-id="element-153" data-mp="woicuzryd9ad" />} data-id="element-152" data-mp="wp1mzubd2tdu" />
        </Routes>
      </Suspense>
    </BrowserRouter>;
}